module.exports = __webpack_public_path__ + "static/img/douyin.5a0f748.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/community/douyin.png
// module id = DIYq
// module chunks = 7